import { Component, inject, Input, TemplateRef, ViewChild } from '@angular/core';
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { NgZorroModule } from '../../../../shared/modules/ng-zorro/ng-zorro.module';
import { CommonModule } from '@angular/common';
import { TimesheetNewEntriesComponent } from '../timesheets-add-entries/timesheets-add-entries.component';
import { DialogConfig, DialogService } from '../../../../shared/services/dialog.service';
import { TableRowActionsModel } from '../../../../shared/interfaces/list.interface';
import { TableRowActions } from '../../../../shared/interfaces/actions';
import { TimesheetFilterComponent } from "../timesheet-filter/timesheet-filter.component";
import { TimesheetService } from '../../../../services/timesheet.service';
import { ListService } from '../../../../shared/services/list.service';
import { TimesheetDetailViewComponent } from "../timesheet-detail-view/timesheet-detail-view.component";
import { AccordionComponent } from "../../../../shared/components/accordion/accordion.component";
import { PDFFormConfig } from '../../../../interfaces/config';
import { HttpResponse } from '@angular/common/http';
import { EditpdfComponent } from '../../../editpdf/editpdf.component';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'ppl-timesheet-provider-processed-list',
  standalone: true,
  imports: [ListTableComponent, NgZorroModule, CommonModule,
    TimesheetFilterComponent, TimesheetDetailViewComponent, AccordionComponent, EditpdfComponent],
  templateUrl: './timesheet-provider-processed-list.component.html',
  styleUrl: './timesheet-provider-processed-list.component.css',
})
export class TimesheetProviderProcessedListComponent {
  @ViewChild('timesheetDialog') timesheetDialog!: TemplateRef<any>;
  @ViewChild('timesheetViewDialog') timesheetViewDialog!: TemplateRef<any>;
  @ViewChild('pdfDialog') pdfDialogRef!: TemplateRef<any>;
  @ViewChild(ListTableComponent) childComponent!: ListTableComponent;

  private dialogSvc = inject(DialogService);
  actionButtons: TableRowActionsModel = new TableRowActions({ view: true });
  appliedFilters: any;
  selectedRow: any;
  viewDialogId: any;
  providerId: any;
  excludeList = ['serviceDuration', 'payrollStartDate', 'payrollEndDate', 'payrollId', 'providerId', 'headerId'];

  filterFields = [
    { field: 'Timeframe', show: true, default: '30 days' },
    { field: 'status', show: true, default: 'P' },
    { field: 'consumer', show: true },
    { field: 'payPeriod', show: true },
  ];

  cols = [
    {
      field: 'payPeriod',
      header: 'Pay Period',
      jsonpath: 'payPeriod',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'providerName',
      header: 'PA Name',
      jsonpath: 'providerName',
      isDisplayedAtHeader: 'y',
      isSearchable: 'y',
    },
    {
      field: 'providerPplId',
      header: 'PA PPL ID',
      jsonpath: 'providerPplId',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'total_paid_amount',
      header: 'Gross Amount',
      jsonpath: 'grossAmount',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'paymentDate',
      header: 'Payment Date',
      jsonpath: 'paymentDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'chequeAmount',
      header: 'Check Amount',
      jsonpath: 'chequeAmount',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'chequeNumber',
      header: 'Check Number',
      jsonpath: 'chequeNumber',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
  ];

  lineItemCols = [
    {
      field: 'consumerName',
      header: 'Consumer',
      jsonpath: 'consumerName',
      isDisplayedAtHeader: 'y',
      isSearchable: 'y',
    },
    {
      field: 'consumerPplId',
      header: 'Consumer PPL ID',
      jsonpath: 'consumerPplId',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'servicePeriodDesc',
      header: 'Service Period',
      jsonpath: 'servicePeriodDesc',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'totalLines',
      header: 'Total',
      jsonpath: 'totalLines',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    }
  ];
  programName!: string;
  payPeriod: any[] = [];
  timesheets: any[] = [];
  selectedLineItem!: any;
  selectedRowData!: any;
  pdfConfig?: PDFFormConfig;
  pdfFile?: string;
  pdfBlob?: Blob;
  showModal = false;
  modalBody = {
    pdfViewer: ''
  };
  @Input() isReadOnly = false;

  constructor(private listService: ListService, private timesheetService: TimesheetService, private userService: UserService) { }

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();
    this.providerId = JSON.parse(this.userService.getSelectedLead()!);
    this.programName = selectedProgram?.program_code ?? '';
    const userDetails = this.userService.getUserDetails();
    const isInRole = selectedProgram?.roles.some((role: any) => role.role_name === 'PPL Staff Tier 1') && userDetails?.usertype_lkp === 'FMS';
    if (isInRole) {
      this.isReadOnly = true;
    }
    this.onSearch({});
  }

  buildRequestPayload(pageName: string, orderBy: string, searchParams: [], startingPageNumber = 1) {
    if (searchParams.length == 0) {
      //handle the error here
      return;
    }

    const payload: any = {
      pageName: pageName,
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: startingPageNumber,
      searchParam: searchParams,
      orderByColumn: [orderBy],
      orderBy: ['desc'],
    };
    return payload;
  }

  searchTimesheets(filters: any, startingPageNumber = 1, currentPage = 0) {
    const processedPayload = this.buildRequestPayload(
      'stafftimesheetlist',
      'tasMasterPayrollScheduleId',
      filters,
      startingPageNumber
    );
    this.listService
      .getListData(processedPayload, 'claims')
      .subscribe((data: any) => {
        const records = this.processData(data.responsedata);
        if (startingPageNumber > 1) {
          this.timesheets = [...this.timesheets, ...records];
          this.childComponent.resetPagination(startingPageNumber, currentPage);
        } else {
          this.timesheets = records;
        }
      });
  }

  onNewTimesheet() {
    this.openAddPopup();
  }

  handleCancel() {
    this.selectedRowData = undefined;
    this.selectedLineItem = undefined;
  }

  onPageLoad(event: any) {
    this.searchTimesheets(this.appliedFilters, event.startingPageNumber, event?.first ?? 0);
  }

  processData(data: any) {
    if (data && data.length > 0) {

      data = this.filterDuplicates(data);

      data.forEach((element: any) => {
        element.payPeriod = element.payrollStartDate + ' - ' + element.payrollEndDate
      });

      data.sort((a: any, b: any) => {
        const dateA = new Date(a.payrollStartDate);
        const dateB = new Date(b.payrollStartDate);
        return dateA.getTime() - dateB.getTime(); // Sorts in ascending order
      });

      return data;
    }

    return data;
  }

  filterDuplicates(payrollList: any[]): any[] {
    const uniquePayrolls = new Set<string>();

    return payrollList.filter((payroll) => {
      const uniqueKey = `${payroll.tasMasterPayrollScheduleId}-${payroll.providerId}-${payroll.payrollEndDate}-${payroll.payrollStartDate}-${payroll.chequeNumber}`;

      if (uniquePayrolls.has(uniqueKey)) {
        return false; // Duplicate, filter it out
      } else {
        uniquePayrolls.add(uniqueKey);
        return true; // Keep the first occurrence
      }
    });
  }

  onSearch(event: any) {
    const filters = [];
    filters.push({
      jsonPath: "serviceDuration",
      value: event.Timeframe ? event.Timeframe : '30 days',
      operator: "lessThan"
    });

    filters.push({
      jsonPath: "providerId",
      value: this.providerId,
      operator: "Equal"
    });

    if (event.consumer && event.consumer.trim()) {
      filters.push({
        jsonPath: "consumerName",
        value: event.consumer.trim(),
        operator: "Equal"
      });
    }

    if (event.status) {
      filters.push({
        jsonPath: "businessStatus",
        value: event.status,
        operator: "Equal"
      });
    } else {
      filters.push({
        jsonPath: "businessStatus",
        value: 'P',
        operator: "Equal"
      });
    }

    if (event.payPeriod) {
      filters.push({
        jsonPath: "servicePeriodId",
        value: event.payPeriod,
        operator: "Equal"
      });
    }

    this.appliedFilters = filters;
    this.searchTimesheets(filters);
  }

  onAction(event: any) {
    if (event.action === 'view') {
      this.selectedRowData = event.param;
      this.selectedLineItem = event.data;
      this.onView();
    }
  }

  onView() {
    this.openViewPopup();
  }

  rowClicked(event: any) {
    if (event.loaded) {
      event.showLineItem = !event.showLineItem;
      return;
    }

    this.appliedFilters = this.appliedFilters.filter((e: any) => !this.excludeList.includes(e.jsonPath));
    this.appliedFilters.push({
      jsonPath: "payrollId",
      value: event.tasMasterPayrollScheduleId,
      operator: "Equal"
    });

    this.appliedFilters.push({
      jsonPath: "providerId",
      value: event.providerId,
      operator: "Equal"
    });

    this.appliedFilters.push({
      jsonPath: "headerId",
      value: event.headerId,
      operator: "Equal"
    });

    this.selectedRow = event;
    this.getStaffTimesheetSubrow(this.appliedFilters, event);
  }

  getStaffTimesheetSubrow(filters: any, event: any) {
    const processedPayload = this.buildRequestPayload(
      'stafftimesheetByConsumerList',
      'masterPayrollScheduleId',
      filters
    );
    this.listService
      .getListData(processedPayload, 'claims')
      .subscribe((data: any) => {
        event.lineItems = data.responsedata;
        event.lineItems.forEach((element: any) => {
          element.servicePeriodDesc = element.serviceStartDate + ' - ' + element.serviceEndDate
        });

        event.lineItems.sort((a: any, b: any) => {
          const dateA = new Date(a.serviceStartDate);
          const dateB = new Date(b.serviceStartDate);
          return dateA.getTime() - dateB.getTime(); // Sorts in ascending order
        });

        event.showLineItem = true;
        event.loaded = true;
      });
  }

  onProcessComplete(event: any) {
    this.dialogSvc.closeDialog(this.viewDialogId);
    this.viewDialogId = null;
    this.getStaffTimesheetSubrow(this.appliedFilters, this.selectedRow);
  }

  openAddPopup() {
    const dialogConfig: DialogConfig = {
      title: 'Add New Time Entries',
      isOkText: 'Save',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.timesheetDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }


  openViewPopup() {
    const dialogConfig: DialogConfig = {
      title: 'Timesheet',
      isOkText: 'Save',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.viewDialogId = this.dialogSvc.openDialog(
      this.timesheetViewDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }


  rowActions(event: any) {
    if(event.type === 'download' ){
      this.timesheetService.downloadPaystub(event)
    }
    else{
      this.viewPaystub(event);
    }
  }

  viewPaystub(event: any) {
    this.showModal = true;
    this.modalBody.pdfViewer = 'Paystub';

    this.pdfConfig = {
      form_id: '',
      is_mandatory: false,
      form_description: '',
      form_name: '',
      fields: []
    };

    const dialogConfig: DialogConfig = {
      title: this.modalBody.pdfViewer,
      isOkText: 'Save',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    }

    this.dialogSvc.openDialog(this.pdfDialogRef, dialogConfig, () => this.handleCancel(), () => this.handleCancel());

    this.getPaystub(event.event.checkId, event.event.providerPplId);
  }

  getPaystub(checkId: string, empId: string) {
    this.timesheetService.getPayStub(checkId, empId).subscribe((response: HttpResponse<Blob>) => {
      if (response.body) {
        const blob = new Blob([response.body], { type: response.body.type });
        this.pdfBlob = blob;
        this.pdfFile = window.URL.createObjectURL(blob);
      }
    });
  }
}
